// extracted by mini-css-extract-plugin
export default {"container":"_2ukby","square":"mIaVz","wide":"TBqIf"};